// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_kT6","tabsBox":"styles_tabsBox__3qINs","createButton":"styles_createButton__1ZzAQ"};